import http from "plugins/axios";

export default {
  getSummaryList(data) {
    return http.post({ url: "/ta/admin/user/dataStatistic/list", data });
  },
  getSummary(data) {
    return http.post({ url: "/ta/admin/user/dataStatistic/summary", data });
  },
  exportSummary(data) {
    return http.post({
      url: "/ta/admin/user/dataStatistic/export",
      data,
      responseType: "blob",
    });
  },
  getDailyList(data) {
    return http.post({ url: "/ta/admin/user/dataStatistic/daily/list", data });
  },
  getDailySummary(data) {
    return http.post({
      url: "/ta/admin/user/dataStatistic/daily/summary",
      data,
    });
  },
  exportDaily(data) {
    return http.post({
      url: "/ta/admin/user/dataStatistic/daily/export",
      data,
      responseType: "blob",
    });
  },
};
